// src/components/common/SectionTitle.tsx

import React from 'react';
import { Title, Text, Stack } from '@mantine/core';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center' | 'right';
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  align = 'center',
}) => {
  return (
    <Stack gap="xs" align={align} mb={40}>
      
      {/* TITLE */}
      <Title
        order={2}
        className="
          text-[3rem]
          sm:text-[4rem]
          md:text-[5rem]
          lg:text-[6rem]
          xl:text-[7rem]
        "
        fw={800}
        style={{
          background:
            'linear-gradient(135deg, #2E7D32 0%, #1B5E20 100%)',

          WebkitBackgroundClip: 'text',

          WebkitTextFillColor: 'transparent',

          display: 'inline-block',

          lineHeight: 1.1,
        }}
      >
        {title}
      </Title>

      {/* SUBTITLE */}
      {subtitle && (
        <Text
          c="dimmed"
          maw={700}
          className="
            text-[1.2rem]
            sm:text-[1.5rem]
            md:text-[1.8rem]
            lg:text-[2.1rem]
            xl:text-[2.5rem]
          "
          style={{
            textAlign: align,
            lineHeight: 1.7,
          }}
        >
          {subtitle}
        </Text>
      )}
    </Stack>
  );
};